import { FC } from 'react';

interface ExclamationIconIconProps {
  width?: string;
  height?: string;
  color?: string;
}

export const ExclamationIcon: FC<ExclamationIconIconProps> = ({ width = '18', height = '16', color = '#DD524C' }) => {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width={width} height={height} viewBox="0 0 18 16" fill="none">
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M6.83406 1.50265C7.79613 -0.164944 10.2029 -0.164945 11.165 1.50265L17.2936 12.1256C18.2551 13.7922 17.0523 15.8749 15.1281 15.8749H2.87091C0.94677 15.8749 -0.256088 13.7922 0.705451 12.1256L6.83406 1.50265ZM8.99969 5.87482C9.34487 5.87482 9.62469 6.15464 9.62469 6.49982V9.62482C9.62469 9.96999 9.34487 10.2498 8.99969 10.2498C8.65452 10.2498 8.37469 9.96999 8.37469 9.62482V6.49982C8.37469 6.15464 8.65452 5.87482 8.99969 5.87482ZM8.99969 12.7498C9.34487 12.7498 9.62469 12.47 9.62469 12.1248C9.62469 11.7796 9.34487 11.4998 8.99969 11.4998C8.65452 11.4998 8.37469 11.7796 8.37469 12.1248C8.37469 12.47 8.65452 12.7498 8.99969 12.7498Z"
        fill={color}
      />
    </svg>
  );
};
